module.exports = __webpack_public_path__ + "img/features_scorebuilder_phone_mobile1.1d6b6079.jpg";